import "./style";
import App from "./components/App";

export default App;
